import ObjectCopyService from "external-services/object-copy-service/index";
import BlockOutsService from "external-services/blockouts-service/blockouts.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import moment from "moment";
import {ChangeLogOperation} from "app/app.types";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import PouchActions, {PouchActionsNames, PouchDocType} from 'app/actions/pouch.actions';
import PouchSyncService from 'external-services/pouch-sync-service';
import store from 'appRoot/Store';
import {setSelectedSchedule} from 'app/reducers/schedule/slice';
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'internal-services/locale/locale.service';

const NS = 'BlockOutsCtrl'; // jshint ignore:line

export default function BlockOutsCtrl(
  $log, $state, $scope, $mdDialog, $filter, appConstants, unregister, $rootScope
) {
"ngInject";

  var vm = this;

  //-- define public properties
  vm.loading = true;
  vm.repeatTypes = appConstants.Blockout.RepeatTypes;
  vm.sortBy = 'startDate';
  vm.sortReversed = true;
  vm.sortOptions = [{
    value: 'startDate',
    label: 'Start Date'
  }, {
    value: 'endDate',
    label: 'End Date'
  }, {
    value: 'name',
    label: 'Name'
  }];

  //-- define public methods
  vm.newBlockout = newBlockout;
  vm.deleteBlockout = deleteBlockout;
  vm.edit = edit;
  vm.getDateRangeDisplay = getDateRangeDisplay;
  vm.changeSortBy = changeSortBy;
  vm.changeSortDirection = changeSortDirection;
  vm.getRepeatStr = (...args) => BlockOutsService.getRepeatStr(...args);
  vm.getErrors = (...args) => BlockOutsService.getErrors(...args);
  vm.showDeleteConfirmation = false;
  vm.errorMessage = '';
  vm.handleDeleteConfirmed = handleDeleteConfirmed;
  vm.handleDeleteCancelled = handleDeleteCancelled;
  vm.blockoutToDelete = null;
  vm.staffNameRequired = false;
  PouchActions.handlePouchSyncedDoctype(PouchDocType.receiveChange, (evt, docs) => {
    if (docs && docs.length === 1 && PouchSyncService.checkDocIdPrefix(docs, 'blockout')) {
      loadBlockouts();
    }
  });

  //-- listen
  var listeners = [];
  listeners.push($scope.$watch('vm.searchStr', filterBlockouts));
  listeners.push($scope.$watch('vm.searchDate', loadBlockouts));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  //Calling general settings to check if staffname is required for delete
  getGeneralSettings();

  function changeSortDirection() {
    vm.sortReversed = !vm.sortReversed;
    changeOrder();
  }

  function changeSortBy() {
    vm.sortReversed = false;
    changeOrder();
  }

  function loadBlockouts() {
    var load;
    if (vm.searchDate && vm.searchDate instanceof Date) {
      load = BlockOutsService.getBlockoutsOnDate(vm.searchDate);
    } else {
      load = BlockOutsService.getAll();
    }

    load.then(function (blockouts) {
      vm.blockouts = blockouts;
      vm.filteredBlockouts = vm.blockouts;
      changeOrder();
      vm.loading = false;
    }).catch(function (err) {
      $log.error('Blockouts failed to load', err);
    });
  }

  function changeOrder() {
    vm.orderedBlockouts = $filter('orderBy')(vm.filteredBlockouts,
      function (blockout) {
        if (vm.sortBy === 'name') {
          return blockout[vm.sortBy] === '' ? 'zzzzzzz' : blockout[vm.sortBy];
        }
        if (vm.sortBy === 'startDate') {
          return (!blockout.repeatType || blockout.repeatType === appConstants.Blockout.RepeatTypes.NoRepeat) ? blockout.startDateTime : blockout.startDate;
        }
        if (vm.sortBy === 'endDate') {
          return (!blockout.repeatType || blockout.repeatType === appConstants.Blockout.RepeatTypes.NoRepeat) ? blockout.endDateTime : blockout.endDate;
        }

        /* The 'zzzzzz' forces the empty names to the end,
          I can't think of a simpler way at the moment. */
      }, vm.sortReversed);
  }

  function filterBlockouts() {
    if (vm.searchStr && vm.blockouts) {
      var lowercaseQuery = vm.searchStr.toLowerCase();
      var filterList = [];
      for (var i = vm.blockouts.length - 1; i >= 0; i--) {
        var blockout = vm.blockouts[i];
        if (blockout.name && blockout.name.toLowerCase().indexOf(lowercaseQuery) !== -1) {
          filterList.push(blockout);
        } else {
          var typeString = 'single blockout';
          if (blockout.repeatType && blockout.repeatType !== appConstants.Blockout.RepeatTypes.NoRepeat) {
            typeString = blockout.repeatType;
          }
          if (blockout.name && typeString.indexOf(lowercaseQuery) !== -1) {
            filterList.push(blockout);
          }
        }
      }

      vm.filteredBlockouts = filterList;
      changeOrder();

    } else {
      vm.filteredBlockouts = vm.blockouts;
      changeOrder();
    }
  }

  function getGeneralSettings()
  {
    GeneralSettingsService.get().then(function (settings) {

      if (settings.staffRequiredEditBlockout && vm.mode !== 'new')
      {
          vm.staffNameRequired = settings.staffRequiredEditBlockout;

      }

    });
  }

  function deleteBlockout(evt, blockout) {
    vm.blockoutToDelete = blockout;
    vm.errorMessage = 'Delete blockout ' + blockout.name;
    vm.showDeleteConfirmation = true;
  }

  function handleDeleteConfirmed(staffName)
    {
      console.log('staff name', staffName);

      vm.showDeleteConfirmation = false ;
      populateLoggingObjectForDelete(vm.blockoutToDelete).then(function(blockoutChanges) {

        // CLI-165: Grid Sync notification is fired centrally in BlockOutsService.remove
        BlockOutsService.remove(vm.blockoutToDelete).then(function () {

          // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
          // ChangeLoggerService.save(blockoutChanges, 'changelog_blockouts', staffName, vm.blockoutToDelete.name);
          vm.blockoutToDelete = null;
          loadBlockouts();
          store.dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));
          console.log("[BLOCKOUT UPDATE] - Updating changes");
        })
      }
    )}

    function handleDeleteCancelled()
    {
      vm.showDeleteConfirmation = false ;
      console.log("[BLOCKOUT UPDATE] - cancelled delete");
    }

  function newBlockout() {
    $state.go('settings.blockouts.edit', {
      id: 'new'
    });
  }

  function edit(blockout) {
    $state.go('settings.blockouts.edit', {
      id: encodeURIComponent(blockout._id)
    });
  }

  function getDateRangeDisplay(blockout) {
    var dateStrParts = [];
    if (blockout.repeatType === vm.repeatTypes.Close) {

      var startDataStr = LocaleService.formatDate(blockout.startDate, 'medium');

      var end = ObjectCopyService.angularSafeCopy(blockout.endDate);

      // End date is saved as next day 4AM, before edit need to set it back one day

      if (DateUtilsService.isTimeEqualsDayEnd(blockout.startDate)
        && DateUtilsService.isTimeEqualsDayEnd(blockout.endDate)) {
        end.setDate(end.getDate() - 1);
      }

      var endDateStr = LocaleService.formatDate(end, 'medium');

      if (startDataStr === endDateStr) {
        dateStrParts.push(startDataStr);
      } else {
        dateStrParts.push('from the ' + startDataStr);
        dateStrParts.push('until ' + endDateStr);
      }

    } else if (!blockout.repeatType || blockout.repeatType === vm.repeatTypes.NoRepeat) {
      dateStrParts.push($filter('date')(blockout.startDateTime, 'h:mm a') + ' ' + LocaleService.formatDate(blockout.startDateTime, 'medium'));
      dateStrParts.push(' - ');
      dateStrParts.push($filter('date')(blockout.endDateTime, 'h:mm a') + ' ' + LocaleService.formatDate(blockout.endDateTime, 'medium'));
    } else {
      dateStrParts.push($filter('date')(blockout.startTime, 'h:mm a'));
      dateStrParts.push(' - ');
      dateStrParts.push($filter('date')(blockout.endTime, 'h:mm a'));
      dateStrParts.push('from the ' + LocaleService.formatDate(blockout.startDate, 'medium'));
      if (blockout.endDate) {
        dateStrParts.push('until ' + LocaleService.formatDate(blockout.endDate, 'medium'));
      }

    }
    return dateStrParts.join(' ');
  }

  async function populateLoggingObjectForDelete(blockout)
  {
    let modifiedValue = [];

    modifiedValue.push(
      {
        property: 'Blockout',
        originalValue: blockout.name,
        newValue: '',
        operation: ChangeLogOperation.DeleteData
      }
    );

    if (blockout.startDate) {
      modifiedValue.push(
        {
          property: 'startDate',
          originalValue: `${LocaleService.formatDate(blockout.startDate, 'medium-short')} ${moment(blockout.startTime).format('h:mma')}`,
          newValue: '',
          operation: ChangeLogOperation.DeleteData
        }
      );
    }
    else if (blockout.startDateTime) {
      modifiedValue.push(
        {
          property: 'startDate',
          originalValue: LocaleService.formatDate(blockout.startDateTime, 'medium-short') + ' ' + moment(blockout.startDateTime).format('h:mma'),
          newValue: '',
          operation: ChangeLogOperation.DeleteData
        }
      );
    }

    if (blockout.endDate) {
      modifiedValue.push(
        {
          property: 'endDate',
          originalValue: `${LocaleService.formatDate(blockout.endDate, 'medium-short')} ${moment(blockout.endTime).format('h:mma')}`,
          newValue: '',
          operation: ChangeLogOperation.DeleteData
        }
      );
    }
    else if (blockout.endDateTime) {
      modifiedValue.push(
        {
          property: 'endDate',
          originalValue: LocaleService.formatDate(blockout.endDateTime, 'medium-short') + ' ' + moment(blockout.endDateTime).format('h:mma'),
          newValue: '',
          operation: ChangeLogOperation.DeleteData
        }
      );
    }


    if (blockout.blockedTables && blockout.blockedTables.length > 0) {
      blockout.blockedTables.forEach(
        element => modifiedValue.push(
          {
            property: 'blockedTableNumber:',
            originalValue: element.name,
            newValue: '',
            operation: ChangeLogOperation.DeleteData
          }
        ));
    }
    if (blockout.blockedSections && blockout.blockedSections.length > 0) {
      await getSections(blockout, modifiedValue);
    }
    return modifiedValue;
  }

  function getSections(blockout, modifiedValue) {
    SectionLookupService.getSections().then(function(sections) {

      blockout.blockedSections.forEach(
        (sectionId) => {

          let selectedSection = sections.find((section) => section._id === sectionId);

          if (selectedSection) {
            modifiedValue.push(
              {
                property: 'blockSection',
                originalValue: selectedSection.name,
                newValue: '',
                operation: ChangeLogOperation.DeleteData
              }
            );
          }

        });

    }).catch(function (err) {
      console.error('error getting sections', err);
    });
  }

}

